import { useState, useEffect, useRef } from "react";
import styles from "./CookieBanner.module.css"; // кастомные стили
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const { i18n, t } = useTranslation();
  const lang = i18n.language || "en";
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);
  const bannerRef = useRef(null);

  useEffect(() => {
    if (visible && bannerRef.current) {
      bannerRef.current.focus();
    }
  }, [visible]);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      tabIndex={-1}
      ref={bannerRef}
      className={styles.banner}
      role="dialog"
      aria-live="polite"
      aria-label={t("cookieBanner.ariaLabel")}
    >
      <p className={styles.text}>{t("cookieBanner.message")}</p>
      <div className={styles.bannerCont}>
        <button
          className={styles.button}
          onClick={handleAccept}
          aria-label={t("cookieBanner.buttonAria")}
        >
          {t("cookieBanner.button")}
        </button>
        <p className={styles.text}>
          <Link
            to={`/${lang}/terms`}
            className={styles.link}
            aria-label={t("cookieBanner.privacyLinkAria")}
          >
            {t("cookieBanner.privacyLink")}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CookieBanner;
